import type { ModelInfo, Usage } from "@/lib/types";

/** Characters per token for a rough count (the server's own count is used for finished replies). */
export const CHARS_PER_TOKEN = 3;

export function contextLength(model: ModelInfo | undefined): number | null {
  const n = Number(model?.caps?.context_length);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Tokens the conversation takes now: the last model call of the newest finished answer (its
 * prompt plus what it wrote, which the next prompt contains too). 0 when nothing is known yet.
 */
export function usedTokens(messages: { role: string; status: string; usage?: Usage | null }[]): number {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (m.role !== "assistant" || m.status === "streaming") continue;
    const calls = m.usage?.stats?.calls;
    const last = calls?.[calls.length - 1];
    if (last?.prompt_tokens) return last.prompt_tokens + (last.completion_tokens || 0);
  }
  return 0;
}

export function draftTokens(text: string): number {
  return Math.ceil(text.length / CHARS_PER_TOKEN);
}
